import React from "react";
import { Dispatch, SetStateAction } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField, {
    FilledTextFieldProps,
    OutlinedTextFieldProps,
    StandardTextFieldProps,
    TextFieldProps,
    TextFieldVariants,
} from "@mui/material/TextField";
import dayjs, { Dayjs } from "dayjs";

export default function DateTimeRangePicker(props: {
    fromDateTime: Date;
    toDateTime: Date;
    setFromDateTime: Dispatch<SetStateAction<Date>>;
    setToDateTime: Dispatch<SetStateAction<Date>>;
}) {
    return (
        <div className="row">
            <div className="col-sm-6" id="fromDateInput">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                        label="From"
                        value={dayjs(props.fromDateTime).locale(
                            "America/NewYork"
                        )}
                        onChange={(newValue, _) => {
                            props.setFromDateTime(
                                newValue?.toDate() ?? props.fromDateTime
                            );
                        }}
                        renderInput={(input) => <div>{input}</div>}
                    />
                </LocalizationProvider>
            </div>
            <div className="col-sm-6" id="toDateInput">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                        label="To"
                        value={dayjs(props.toDateTime ?? new Date())}
                        onChange={(newValue, _) => {
                            props.setToDateTime(
                                newValue?.toDate() ?? props.toDateTime
                            );
                        }}
                        renderInput={(input) => <div>{input}</div>}
                    />
                </LocalizationProvider>
            </div>
        </div>
    );
}
